import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f872b7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "data-radius",
  style: {borderRadius: '4px'}
}
const _hoisted_2 = { class: "font-red" }
const _hoisted_3 = { type: "success" }


import { defineComponent, defineProps, ref, onMounted } from 'vue'
import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
import { getI18n, convertUTC2LocalTime2, getCountryNameByMcc, apiPostData, isChinese, isEmptyArray } from '../utils'
import store from '../store'

const __default__ = defineComponent({
  name: 'SimCard'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  simNo: {
    type: String,
    require: true
  }
},
  setup(__props) {

const props = __props

const refHost = ref('')
onMounted(async () => {
  refHost.value = window.location.host
})

const refSimExpireTime = ref('')
const refSimNo = ref('')
const refIccid = ref('')
const refCarrier = ref('')
const refCardTye = ref('')
const refMsisdn = ref('')

function querySimData () {
  store.state.isQueriedSim = !store.state.isQueriedSim
  if (!store.state.isQueriedSim) {
    return
  }
  refSimExpireTime.value = convertUTC2LocalTime2(store.state.simInfo.data.expireTime)
  if (!isEmptyArray(store.state.simInfo.data.realNameCertList)) {
    refRealName1.value = getRealNameResult(0)
    refRealName2.value = getRealNameResult(1)
  }
  refSimNo.value = store.state.simInfo.data.simNo
  refIccid.value = store.state.simInfo.data.iccid
  refMsisdn.value = store.state.simInfo.data.msisdn
  refCarrier.value = store.state.simInfo.data.carrier || store.state.simInfo.data.sourceType
  refCardTye.value = store.state.simInfo.data.cardType

  refLocation.value = ''
  refInstalledDevice.value = ''
  refInstalledStatus.value = ''

  getLocation()
  queryEsimInfo()
}
function getRealNameResult (idx) {
  let certStatus = store.state.simInfo.data.realNameCertList[idx].certStatus
  const region = store.state.simInfo.data.realNameCertList[idx].region

  const certStatusMap = {
    Uncertified: '未实名',
    ToBeCertified: '待认证',
    Certifying: '认证中',
    Certified: '已认证',
    CertFailed: '认证失败',
    CertExpired: '实名过期',
    Unknow: '未知'
  }

  if (isChinese()) {
    certStatus = certStatusMap[certStatus]
  }

  return region + ' : ' + certStatus
}

const refIsExpand = ref(false)
const refRealName1 = ref('')
const refRealName2 = ref('')
const refLocation = ref('')
function getLocation () {
  refLocation.value = ''
  const data = { simNo: store.state.simInfo.data.simNo }
  apiPostData('/h5/v1/sim/get-location', data)
    .then(data => {
      console.log('getLocation', data)
      if (data !== null && data !== undefined && data.code === 'ok') {
        refLocation.value = getCountryNameByMcc(data.data.mcc)
      }
    })
}

const refInstalledDevice = ref('')
const refInstalledStatus = ref('')

function queryEsimInfo () {
  if (getCardType() !== 'ESIM') {
    return
  }
  refLocation.value = ''
  const data = { simNo: store.state.simInfo.data.simNo }
  apiPostData('/h5/v1/esim/get-info', data)
    .then(data => {
      console.log('queryEsimInfo', data)
      if (data !== null && data !== undefined) {
        console.log('queryEsimInfo', data)
        if (data.code === 'ok') {
          data = data.data
          refInstalledDevice.value = data.installDevice
          refInstalledStatus.value = data.status
          if (data.status === 'Released') {
            refInstalledStatus.value = getI18n('未安装', 'Uninstall')
          } else if (data.status === 'Installed') {
            refInstalledStatus.value = getI18n('已安装', 'Installed')
          } else if (data.status === 'Enable') {
            refInstalledStatus.value = getI18n('启用', 'Enable')
          } else if (data.status === 'Disable') {
            refInstalledStatus.value = getI18n('停用', 'Disable')
          } else if (data.status === 'Unkown') {
            refInstalledStatus.value = getI18n('未知', 'Unkown')
          }
        }
        if (data.code === 'is_pyhsical_card') {
          refInstalledDevice.value = getI18n('物理卡', 'Physical Card')
        }
      }
    })
}
function getCarrier () {
  if (refCarrier.value === 'SS') {
    return getI18n('S卡', 'S Card')
  }
  return refCarrier.value
}
function getCardType () {
  if (refCardTye.value === 'ESIM') {
    return getI18n('ESIM', 'ESIM')
  }
  return getI18n('物理卡', 'Physical Card')
}

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      class: "card-row",
      gutter: 15,
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 15 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, { class: "mx-1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('查询地址', 'Query Website')) + ":", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_text, { class: "mx-1" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, "https://" + _toDisplayString(refHost.value) + "/", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 9,
          class: "col-button"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              plain: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (querySimData()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getI18n)('查询SIM卡','Query SIM')), 1),
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    (!refIsExpand.value)
                      ? (_openBlock(), _createBlock(_unref(ArrowDown), { key: 0 }))
                      : _createCommentVNode("", true),
                    (refIsExpand.value)
                      ? (_openBlock(), _createBlock(_unref(ArrowUp), { key: 1 }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(store).state.isQueriedSim)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('卡号', 'SimNo')) + ":", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(refSimNo.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('ICCID', 'ICCID')) + ":", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(refIccid.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('msisdn', 'msisdn')) + ":", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(refMsisdn.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('运营商', 'Carrier')) + ":", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getCarrier()), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('卡类型', 'Card Type')) + ":", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getCardType()), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('SIM卡过期时间', 'SIM Expire Time')) + ":", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(refSimExpireTime.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (refRealName1.value)
            ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0,
                class: "card-row",
                gutter: 20,
                align: "middle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 9,
                    class: "col-title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_text, { class: "mx-1" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(getI18n)('实名结果', 'Real Name Result')) + ":", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (refRealName1.value)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 15
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_text, {
                            class: "mx-1",
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(refRealName1.value), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }),
              (refRealName2.value)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    span: 15
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_text, {
                        class: "mx-1",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(refRealName2.value), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (getCardType ()=='ESIM')
            ? (_openBlock(), _createBlock(_component_el_row, {
                key: 1,
                class: "card-row",
                gutter: 20,
                align: "middle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 9,
                    class: "col-title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_text, { class: "mx-1" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(getI18n)('ESIM安装设备', 'Installed Device')) + ":", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 15 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_text, {
                        class: "mx-1",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(refInstalledDevice.value), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (getCardType ()=='ESIM')
            ? (_openBlock(), _createBlock(_component_el_row, {
                key: 2,
                class: "card-row",
                gutter: 20,
                align: "middle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 9,
                    class: "col-title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_text, { class: "mx-1" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(getI18n)('ESIM安装状态', 'Installed Status')) + ":", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 15 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_text, {
                        class: "mx-1",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(refInstalledStatus.value), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_row, {
            class: "card-row",
            gutter: 20,
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 9,
                class: "col-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, { class: "mx-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getI18n)('当前位置', ' Current Location')) + ":", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 15 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    class: "mx-1",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(refLocation.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})